import { createStyles, makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() =>
  createStyles({
    modalTitle: {
      marginTop: '26px',
      marginBottom: '75px',
      marginLeft: '23px',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 18,
      lineHeight: '21px',
      color: '#2C2D3E',
    },
    leftFormInput: {
      padding: '0px',
      width: '320px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '59px',
      marginBottom: '26px',
      appearance: 'none',
    },
    rightFormInput: {
      padding: '0px',
      width: '320px',
      height: '50px',
      borderRadius: '3px',
      boxSizing: 'border-box',
      marginLeft: '20px',
      appearance: 'none',
    },
    leftText: {
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'bold',
      fontSize: 14,
      lineHeight: '16px',
      color: '#2C2D3E',
      marginLeft: '50px',
    },
    rightText: {
      marginBottom: '8px',
      position: 'relative',
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 'normal',
      fontSize: 14,
      lineHeight: '16px',
      color: '#2C2D3E',
      verticalAlign: 'center',
      marginLeft: '50px',
    },
    actionIcon: {
      position: 'relative',
      top: '1px',
      color: '#3C419A',
      cursor: 'pointer',
    },
    personalUserData: {
      marginLeft: '0px',
    },
    activeText: {
      fontFamily: 'Roboto',
      color: '#3C419A',
      fontSize: '15px',
      fontWeight: 700,
      position: 'relative',
      top: '5px',
      left: '15px',
      cursor: 'pointer',
    },
    active: {
      position: 'relative',
      left: '14px',
      marginRight: '100px',
      width: '191px',
      height: '35px',
      padding: '5px 0px',
      backgroundColor: 'rgba(202, 202, 252, 0.15)',
      borderRadius: '3px',
      cursor: 'pointer',
    },
    inactiveText: {
      fontFamily: 'Roboto',
      color: '#2C2D3E',
      fontSize: '15px',
      fontWeight: 500,
      position: 'relative',
      top: '5px',
      left: '15px',
      cursor: 'pointer',
    },
    inactive: {
      position: 'relative',
      left: '14px',
      marginRight: '38px',
      width: '191px',
      height: '35px',
      padding: '5px 0px',
      backgroundColor: '#FFFFFF',
      cursor: 'pointer',
    },
  }),
);

export const styles = () =>
  createStyles({
    root: {
      height: '539px',
      width: '820px',
      margin: 0,
      padding: 0,
    },
  });

export const styles2 = () =>
  createStyles({
    root: {
      width: '768px',
      margin: 0,
      padding: 0,
    },
  });
